import React from "react";

type AvatarInitialsProps = {
  name: string;
  size?: number;        
  backgroundColor?: string;
  textColor?: string;
  fontSize?: number;   
};

const getInitials = (name: string): string => {
  if (!name) return "";

  const parts = name
    .trim()
    .split(" ")
    .filter(p => p.length > 0);

  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }

  const first = parts[0][0];
  const last = parts[parts.length - 1][0];

  return (first + last).toUpperCase();
};

export const Avatar: React.FC<AvatarInitialsProps> = ({
  name,
  size = 48,
  backgroundColor = "#4f8f8b",
  textColor = "#ffffff",
  fontSize
}) => {
  const initials = getInitials(name);

  const resolvedFontSize = fontSize ?? Math.floor(size * 0.4);

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor,
        color: textColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 600,
        fontSize: resolvedFontSize,
        userSelect: "none"
      }}
      title={name}
    >
      {initials}
    </div>
  );
};
